import { Lightning } from "@/frontend/SVGs/Lightning";
import { I18n } from "@/i18n/I18n";
import { useState } from "react";
import { SelectFunctionalInterfaceModal } from "./SelectFunctionalInterfaceModal";
import { useFunctionalInterfacesStore } from "@/frontend/store/FunctionalInterfaceStore";
import { useTreeStore } from "@/frontend/store/TreeStore";
import { Container } from "@/backend/models/containers/container";

export function CallFunctionButton(props: { parent: Container, position: number }) {
  const { parent, position } = props;
  const [showModal, setShowModal] = useState(false);
  const functionalInterfaces = useFunctionalInterfacesStore((state) => state.functionalInterfaces);
  const versionsInProcedure = useFunctionalInterfacesStore((state) => state.functionalInterfaceVersions);
  const filteredFunctionalInterfaces = functionalInterfaces.filter((functionalInterface) => versionsInProcedure.some((version) => version.functionalInterfaceId === functionalInterface.id));
  const createContainerFromFunction = useTreeStore((state) => state.createContainerFromFunction);

  function onSubmit(interfaceInstanceFunctionId: string) {
    void createContainerFromFunction({ 
      parentId: parent.id,
      position,
      rootId: parent.rootId,
      interfaceInstanceFunctionId,
    });
  }
  
  return (
    <>
      <button className='btn btn-sm btn-primary' onClick={() => setShowModal(true)}><div className='d-flex align-items-center gap-1'><Lightning />{I18n.get('callInterfaceFunction')}</div></button>
      {showModal && <SelectFunctionalInterfaceModal setShowModal={setShowModal} functionalInterfaces={filteredFunctionalInterfaces} onSubmit={({ functionId }) => void onSubmit(functionId)} selectingFunction />}
    </>
  );
}
